import { createStore } from 'vuex'
// import createPersistedState from 'vuex-persistedstate'


import modules from './modules'

const store = createStore({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    // biar saat di refresh gak ilang
    // createPersistedState({
    //   key: 'sales-app',       // optional, biar jelas
    //   paths: ['tiroorder'],   // ⚠️ nama module kamu
    //   storage: window.sessionStorage, // atau localStorage
    // })
  ]
})

export default store

